import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
	providedIn: 'root'
})
export class ToastService {

	constructor(private toastController: ToastController) { }

	async Toast(message: string,
		cssClass: string,
		duration: number = 1500) {
		const toast = await this.toastController.create({
			message: message,
			duration: duration,
			// showCloseButton: true,
			// closeButtonText: 'x',
			cssClass: cssClass
		});

		toast.present();
	}
}
